import { createFileRoute } from "@tanstack/react-router";
import { ProposalWizard } from "@/modules/proposal-builder/components/wizard/ProposalWizard";

export const Route = createFileRoute("/new")({
  component: ProposalBuilderNewRoute,
});

function ProposalBuilderNewRoute() {
  return <ProposalWizard />;
}